<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-11 16:47:27
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="40%"
      @close="close"
    >
      <!-- <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="备注" prop="sysRemark">
          <el-input
            v-model="form.sysRemark"
            type="textarea"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form> -->
      <el-descriptions title="">
        <el-descriptions-item label="姓名">{{
          this.form.userName
        }}</el-descriptions-item>
        <el-descriptions-item label="预约时间">{{
          this.form.appointmentTimeEnd
        }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{
          this.form.orderTime
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="备注">
          <el-tag size="small">学校</el-tag>
        </el-descriptions-item> -->
        <el-descriptions-item label="联系方式">{{
          this.form.phone
        }}</el-descriptions-item>
        <el-descriptions-item label="预约地址">{{
          this.form.detailAddress
        }}</el-descriptions-item>

        <el-descriptions-item label="订单状态">
          <el-tag size="small">{{
            this.form.orderStatus | orderStatus
          }}</el-tag></el-descriptions-item
        >
      </el-descriptions>
      <div class="flow">
        <el-timeline>
          <el-timeline-item
            v-for="(item, i) in form.orderFlowList"
            :key="i"
            :timestamp="item.flowTime"
            placement="top"
          >
            <div style="margin-bottom: 5px">{{ item.flowName }}</div>
            <el-tag type="danger" size="mini" v-show="!!item.betweenMinutes">
              耗时： {{ item.betweenMinutes }}分
            </el-tag>
          </el-timeline-item>
          <!-- <div>耗时：{{ item.betweenMinutes }}分</div> -->
          <!-- <el-timeline-item timestamp="2018/4/3" placement="top">
          </el-timeline-item>
          <el-timeline-item timestamp="2018/4/2" placement="top">
          </el-timeline-item>-->
        </el-timeline>
      </div>

      <span slot="footer">
        <!-- <el-button @click="visible = false" size="mini">取消</el-button> -->
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/sign";

export default {
  components: {},
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      options: [
        { label: "普通用户", value: 0 },
        { label: "管理员", value: 1 },
      ],
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        name: [
          { required: true, message: "请输入姓名!" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        idCard: [{ required: true, message: "请输入身份证号!" }],
      },
      url: {
        edit: "/user/statistical/updateRemark",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    getOrderDetail(orderId) {
      getOrderDetail({ orderId }).then((res) => {
        // this.form = Object.assign(this.form, res.data);
        this.$set(this, "form", Object.assign(this.form, res.data));
        this.$forceUpdate();
      });
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form = Object.assign({}, record);
      this.getOrderDetail(record.orderId);
      this.visible = true;
    },
    close() {
      // this.$refs.form.resetFields();
      this.$emit("close");
      this.visible = false;
    },
    handleOk() {
      this.$emit("close");
      this.visible = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .flow {
    min-height: 200px;
    overflow-y: auto;
  }
  ::v-deep.el-timeline-item__tail {
    border-left: 2px solid #409eff;
  }
  ::v-deep.el-timeline-item__node {
    background-color: #409eff;
  }
}
</style>
